import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-claro-star-rating',
  templateUrl: './claro-star-rating.component.html',
  styleUrls: ['./claro-star-rating.component.scss']
})
export class ClaroStarRatingComponent extends BaseComponent implements OnInit {

  @Input() rating: number = 3;
  @Input() disabled: boolean = false;
  @Output() ratingUpdated = new EventEmitter();
  @ViewChild('divWithDir') divWithDir: HTMLElement;
  totalStar: number = 5;
  ratingArray: number[] = [];

  constructor() {
    super();
   }

  ngOnInit() {
    for (let index = 0; index < this.totalStar; index++) {
      this.ratingArray.push(index);
    }
  }

  ngAfterViewInit() {
    this.divWithDir.dir = this.pageDir;
  }

  calculateRating(rating: number) {
    if (!this.disabled){
      this.rating = rating;
      this.ratingUpdated.emit(rating);
    }
  }

  isStarFilled(index: number) {
    return this.rating >= index + 1
  }
}
